import script from "./EquipmentDB.vue?vue&type=script&setup=true&lang=js"
export * from "./EquipmentDB.vue?vue&type=script&setup=true&lang=js"

import "./EquipmentDB.vue?vue&type=style&index=0&id=78ee6078&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ee6078"]])

export default __exports__